import { AlarmsReport } from "./AlarmsReport";
export default AlarmsReport;
